// Use absolute paths only.

export const EnrolmentRoute = {
  enrolment: "/energy/quote",
  enrolmentAddress: "/energy/quote/address",
  enrolmentProperty: "/energy/quote/property",
  enrolmentTariff: "/energy/quote/tariff",
  enrolmentPersonalDetails: "/energy/quote/personal-details",
  enrolmentPayment: "/energy/quote/payment",
  enrolmentReview: "/energy/quote/review",
  enrolmentComplete: "/energy/quote/complete",
} as const

export type EnrolmentRoute =
  (typeof EnrolmentRoute)[keyof typeof EnrolmentRoute]
